import { useEffect, useState } from "react";

// Header badge: shows the remaining charging window while unlocked, or a button
// to unlock when locked/expired. Counts down off `unlockedUntil` directly so it
// flips to "locked" the moment the window lapses, without refetching status.
export function UnlockCountdown({
  unlockedUntil,
  onUnlock,
}: {
  unlockedUntil: Date | null;
  onUnlock: () => void;
}) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const msLeft = unlockedUntil ? unlockedUntil.getTime() - now : 0;
  if (msLeft <= 0) {
    return (
      <button
        onClick={onUnlock}
        className="px-3 py-2 rounded-lg text-sm font-medium border border-[#E9E9EB] bg-surface-primary text-content-primary hover:bg-surface-secondary"
        title="Enter a code to unlock charging for 60 minutes"
      >
        🔒 Unlock charging
      </button>
    );
  }

  const total = Math.floor(msLeft / 1000);
  const mm = String(Math.floor(total / 60)).padStart(2, "0");
  const ss = String(total % 60).padStart(2, "0");
  return (
    <span
      className="px-3 py-2 rounded-lg text-sm font-medium border border-green-200 bg-green-50 text-green-700 whitespace-nowrap"
      title="Charging is unlocked; it re-locks when this reaches 0"
    >
      🔓 Unlocked · {mm}:{ss}
    </span>
  );
}
